<!-- Snackbar component for displaying temporary messages to the user
     Provides feedback on actions taken by the user, such as success or error messages -->

<template>
  <!-- Snackbar component -->
  <v-snackbar
    v-model="visible"
    :color="snackbarState.snackbarColor"
    :timeout="5000"
    :close-on-content-click="true"
    location="top right"
  >
    {{ snackbarState.message }}
  </v-snackbar>
</template>

<script setup lang="ts">
// State management for snackbar visibility and message
const snackbarState = useState("snackbarMessage", () => ({
  message: "",
  snackbarColor: "success",
  visible: false,
}));

// Computed property to manage the visibility of the snackbar
const visible = computed({
  get: () => snackbarState.value.visible,
  set: (value) => (snackbarState.value.visible = value),
});
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
